<main class="py-16">

			<section id="program-login" class="container mx-auto max-w-screen-xl prose leading-normal px-8 xl:px-0">
				<div class="program-login__intros flex justify-center gap-x-10">
                        <div class="program-login__icon basis-1/4 hidden md:block">
                           
                            <img src="/404.png" alt="404" class="w-100 h-100 object-center object-scale-down my-0"> 
                    </div>
                    
                    <div class="program-login__main md:basis-2/4">
                        
                       <!-- <p class="text-[30px] md:text-[30px] font-weight-bold mt-0 mb-0 ">Hmmm, something is not right here.</p>-->
						
                        <p class="text-[17px] sm:text-[17px] mt-2 mb-0">If you continue to see this page, please contact our Customer Interaction Centre for assistance at <a href="mailto:campaigns.support@syngenta.com?subject=Storen%20Satisfaction%20Program%20-%20Support%20Request" data-measurement="SSP - Sign Up - Support Email" class="pointer"><em>campaigns.support&#64;syngenta.com</em></a></p>
                            <div class="program-login__submit mt-3">
                                <button id="btnback" type="button" class="btn__blue" (click)="goBack()">Go back</button>
                                <button id="btnpage" type="button" class="btn__blue goback xl:inline-block xl:ms-6 lg:inline-block lg:ms-6 md:ms-0 md:inline-block sm:block sm:ms-0 mt-3 " (click)="goBackHome()">Go to home page</button>
                      
                      </div>   
                     
                    </div>   
                    </div>
                   
            </section>
        
		</main>
